import * as go from 'gojs';
import * as uuid from 'uuid';
import { getPointString, getSizeString } from '../../../../../utils/stringify-utils';
import { LAYER_NAME_PROP, Z_ORDER_PROP } from '../../common/config/common-prop-names';
import { ImageNodeCreateProps } from '../models/image-node-create-props';
import { ImageNode } from '../models/image-node.model';
import { bringToFront } from './../../../../../utils/bring-to-front-back/bring-to-front';

export const createImageNode = (diagram: go.Diagram, { categoryName, source, location }: ImageNodeCreateProps) => {
  const key = uuid.v4();

  diagram.commit(() => {
    diagram.model.addNodeData(
      new ImageNode(key, categoryName, source, getPointString(location.x, location.y), getSizeString(NaN, NaN)),
    );
  });

  const node = diagram.findNodeForKey(key);
  if (node) {
    bringToFront(node, Z_ORDER_PROP, LAYER_NAME_PROP);
  }

  return node;
};
